const data: string = "<p ng-if=\"overdraftSummary && overdraftSummary.od_active\" class=\"acp-overdraft-disclosure-message\" cms-html=\"disclosure-message:components/overdraft-domain\"></p>";
export default data